var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "disconnect-popup",
      attrs: {
        visible: _vm.visible,
        "close-on-click-overlay": false,
        size: "small",
        title: _vm.$t.__("email.disconnect_my_email"),
        overlayColor: "dark"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        closed: _vm.closeModal
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("p", { staticClass: "disconnect-popup__text" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "En déconnectant votre compte email, les emails déjà envoyés et reçus sur Sellsy seront conservés mais vous ne pourrez plus en envoyer ou en recevoir des nouveaux."
                )
              ) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog__footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary",
              size: "medium"
            },
            on: { click: _vm.closeModal }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("email.DisconnectPopup.confirm_and_disconnect"),
              type: "primary-destructive",
              size: "medium"
            },
            on: { click: _vm.logout }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }